import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { take } from 'rxjs/operators';

import { RichTextService } from './richtext.service';
@Component({
  selector: 'app-richtext-viewer',
  templateUrl: './richtext-viewer.component.html',
  styleUrls: ['./richtext-viewer.component.scss'],
  standalone: false,
  providers: [RichTextService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RichTextViewerComponent {
  _textValue: SafeHtml;
  constructor(
    private readonly domSanitizer: DomSanitizer,
    private readonly richTextService: RichTextService,
    private cdr: ChangeDetectorRef
  ) {}
  @Input() set htmlModel(value: string) {
    if (value) {
      this.richTextService
        .transformToRichText(value)
        .pipe(take(1))
        .subscribe((richText) => {
          this._textValue = this.domSanitizer.bypassSecurityTrustHtml(richText);
          this.cdr.detectChanges();
        });
    } else {
      this._textValue = undefined;
    }
  }
}
